import PublicApi from '@/services/PublicApi'

export default {
  // List all website projects (no client_id => projects flagged show_on_website).
  // Returns the axios promise so callers/normalizer can read response.data.projects.
  listWebsiteProjects () {
    return PublicApi().get('public/projects')
  },

  // Fetch a single website project by id for the Project_Detail view.
  // The public API exposes the website projects as a list (no dedicated
  // single-project route), so resolve the matching raw project from that list.
  getProject (id) {
    return PublicApi()
      .get('public/projects')
      .then((response) => {
        const projects = (response && response.data && response.data.projects) || []
        const wanted = String(id)
        const project = projects.find((p) => {
          return String(p.id) === wanted || String(p.job_id) === wanted
        })
        return { data: { project: project || null } }
      })
  }
}
